import React, { useEffect } from "react";
import aboutdepartmentimg1 from '../assets/images/aboutdepatmentimg1.webp';
import aboutdepartmentimg2 from '../assets/images/aboutdeparmentimg2.webp';
import AOS from "aos";
import 'aos/dist/aos.css';
const Aboutdepartment = () =>{

        useEffect(() => {
            AOS.init();
            AOS.refresh();
        }, [])
    return(
<div>
    <section className="about-main-section">
<div className="text-center about-tiilte-sec">
<p className="about-tiilte-sec-head">about department</p>
<p className="about-tiilte-sec-subhead"> home <i class="fa fa-angle-double-right    about-bredcumb-arrow" aria-hidden="true"></i>
About Department</p>
</div>
    </section>
      <section className="aboutdepartment-section">
                    <div className="container">
                        <div className="row">
                            <div className="col-12 col-lg-6 order-2 order-lg-1" >
                                <div className="aboutdepartment-left-sec">
                               <p className="ab-depart-subheading" data-aos="fade-up" data-aos-delay="300" data-aos-duration="300">About the Department</p>
                               <p className="home-about-head" data-aos="fade-up" data-aos-delay="600" data-aos-duration="300">SVU Zoology Department</p>
                               <p className="home-about-para" data-aos="fade-up" data-aos-delay="900" data-aos-duration="300">The Department of Zoology was established in 1954 from the inception of the University to produce high quality Zoologists to cater the needs of the newly Independent India. Since the Institute is a State University,
                                 the Department has increasingly focused on post graduate education and research with a vision to promote the discovery and broad communication of knowledge about the physiology of animals. <br/><br />
Zoology Department has been recognized at National and International levels for its outstanding contributions in various disciplines of Animal Physiology. The University Grants Commission has recognized this Department as a Research Centre for the thrust areas “Environmental Biology” and “Ethnopharmacology”.</p>
                                </div>
                            </div>
                            <div className="col-12 col-lg-6 order-2 order-lg-1">
                            <img src={aboutdepartmentimg1} className="home-about-img" />
                            </div>
                        </div>
                    </div>
                </section>
                <section className="aboutdepartmentlegacy-section">
                    <div className="container">
                        <div className="row">
                            <div className="col-12 col-lg-6 order-2 order-lg-1">
                            {/* <img src={aboutdepartmentimg2} className="aboutdepartemnt-img2" /> */}
                            <div className="aboutdepartemnt-img2"></div>
                            </div>
                            <div className="col-12 col-lg-6 order-2 order-lg-1">
                     
                            <div className="aboutdepartment-left-sec">
                            
                               <p className="home-about-head" data-aos="fade-up" data-aos-delay="300" data-aos-duration="300">Department Legacy</p>
                               <p className="home-about-para" data-aos="fade-up" data-aos-delay="600" data-aos-duration="300">All the faculty have received advanced overseas training in their respective research areas and established active research collaborations across the Globe. In due recognition of the research potential and academic accomplishments of the faculty, the Department is being constantly supported with huge grants by several funding agencies namely UGC (DRS, COSIST, BSR), DST-FIST with a total outlay of Rs.280 lakhs. In addition to the above, the faculty members have received individual major research projects to the tune of Rs.196 lakhs from various funding agencies such as UGC, CSIR, DST and ICMR during the last five-year period.<br /><br />

Since its inception, 520 Ph.D., and 393 M.Phil Degrees were awarded and 2200 research papers were published in journals of national and international repute with high impact factor.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
</div>
    )
}
export default Aboutdepartment;